import React, { useEffect, useState } from "react";
import RevenueChart from "@/app/pages/companyProfile/financial/tabs/RevenueChart";
import Reliability from "@/app/pages/companyProfile/financial/Reliability";
import { isNotUndefinedOrNull } from "@/shared/FunctionCore";
import DataMaskingParagraph from "@/components/dataMaskingParagraph/DataMaskingParagraph";
import DataMasking from "@/components/dataMasking/DataMasking";
import { useTranslation } from "react-i18next";

const RevenueChartNew = ({ props, isUnlockData, maskedFinancialData }) => {
  const { t } = useTranslation();
  const [chartData, setChartData] = useState<any>();
  const [clickedButtonIndex, setClickedButtonIndex] = useState<number | null>(
    null
  );
  const dataToPrint = isUnlockData === true ? [props?.aincomeYear, props?.acostOfRevenue, props?.agrossProfit, props?.aoperatingIncome, props?.aincomeBeforeTax, props?.atotalNetIncome, props?.adilutedEPS] : [props?.aincomeYear]
  const formatChartData = (dataArray) => {
    let chartDataFormat = [["label", "Revenue"]];
    dataArray.forEach((objData) => {
      let newData = [];
      if (isNotUndefinedOrNull(objData?.data?.f)) {
        newData.push(objData.data.f.toString());
      }
      if (isNotUndefinedOrNull(objData?.revenue)) {
        newData.push(Number(objData.revenue));
      }
      chartDataFormat.push(newData);
    });
    return chartDataFormat;
  }
  useEffect(() => {
    manipulateDataBasedOnChart(props?.aincomeYear, 0);
    setClickedButtonIndex(1);
  }, []);

  // Remove this props? object once data will come in response and all data1 in this file will be replaced by props


  const manipulateDataBasedOnChart = (data, index = 1) => {
    setClickedButtonIndex(index);
    let chartDataFormat = [["label", "Revenue"]];
    data.map((objData) => {
      let newData = [];
      if (isNotUndefinedOrNull(objData["data"]["f"])) {
        newData.push(objData["data"]["f"].toString());
      }
      if (isNotUndefinedOrNull(objData.revenue)) {
        newData.push(Number(objData.revenue));
      }
      chartDataFormat.push(newData);
    });
    setChartData(chartDataFormat);
  };

  const options = {
    title: "",
    is3D: false,
    legend: { position: "none" },
    lineWidth: 2,
    pointSize: 10,
    vAxis: {
      title: "Revene (in Millions)",
      baselineColor: "#cbcdce",
      format: "$#,###",
      viewWindow: {
        min: 0,
      },
    },
    hAxis: {},
    series: {
      0: {
        pointShape: "circle",
      }
    },
  };

  return (
    <>
    <div className="row d-none d-print-block">
      {dataToPrint.map((data)=>
        <div className="col-md-10 p-2">
          {isUnlockData === true ?
            <RevenueChart chartData={formatChartData(data)} options={options} /> :
            <DataMaskingParagraph dataMasking={maskedFinancialData} />}
        </div>
      )}
    </div>
      {/* <template data-sly-template.revenue_chart="${@ model,properties}"> */}
      <div className="row">
        <div className="col-md-8 d-print-none mt-4">
        {isUnlockData === true ?
          (chartData && (
            <RevenueChart chartData={chartData} options={options} />
          )) : <DataMaskingParagraph dataMasking={maskedFinancialData} />}
        </div>
        <div className="col-md-4">
          <div className="cmp-tabbed-nav-is" role="menubar">
            <button
              aria-controls="tabbed-nav-is-menu"
              aria-expanded="false"
              aria-haspopup="true"
              id="tabbed-nav-is-mobile-button"
            >
              {props?.labelIncomeYear}
            </button>
            <ul
              aria-label="menu"
              className="tabbed-nav-is clearfix tablist financials-dropdown"
              id="tabbed-nav-is-menu"
            >
              {props.renderRevenueChart && (
                <li className="iny" role="none">
                  <button
                    aria-controls="chart_div"
                    aria-selected="true"
                    data-vtab="vtab1"
                    id="iny_tab"
                    role="menuitem"
                    style={{ color: clickedButtonIndex === 1 ? "#3498db" : "" }}
                    onClick={isUnlockData && (() => {
                      manipulateDataBasedOnChart(props?.aincomeYear, 1);
                    })}
                  >
                    <span className="right-buffer">
                      {props?.labelIncomeYear}
                      {!isUnlockData && <Reliability reliability={props?.reliability} />}
                    </span>
                    {isUnlockData && <div>
                      <Reliability reliability={props?.reliability} />
                    </div>}
                  </button>
                </li>
              )}
              {props?.renderCostOfRevenueChart && (
                <li className="cor" role="none">
                  <button
                    aria-controls="chart_div6"
                    aria-selected="false"
                    data-vtab="vtab6"
                    id="cor_tab"
                    role="menuitem"
                    style={{ color: clickedButtonIndex === 2 ? "#3498db" : "" }}
                    onClick={isUnlockData && (() => {
                      manipulateDataBasedOnChart(props?.acostOfRevenue, 2);
                    })}
                  >
                    {isUnlockData === true ? props.labelCostOfRevenue : <span>{t("companyProfile.financial.costOfRevenue")}: <DataMasking /></span>}
                  </button>
                </li>
              )}
              {props?.renderGrossProfitChart && (
                <li className="gp" role="none">
                  <button
                    aria-controls="chart_div2"
                    aria-selected="false"
                    data-vtab="vtab2"
                    id="gp_tab"
                    role="menuitem"
                    style={{ color: clickedButtonIndex === 3 ? "#3498db" : "" }}
                    onClick={isUnlockData && (() => {
                      manipulateDataBasedOnChart(props?.agrossProfit, 3);
                    })}
                  >
                    {isUnlockData === true ? props.labelGrossProfit : <span>{t("companyProfile.financial.grossProfit")}: <DataMasking /></span>}
                  </button>
                </li>
              )}
              {props.renderOperatingIncomeChart && (
                <li className="oi" role="none">
                  <button
                    aria-controls="chart_div3"
                    aria-selected="false"
                    data-vtab="vtab3"
                    id="oi_tab"
                    role="menuitem"
                    style={{ color: clickedButtonIndex === 4 ? "#3498db" : "" }}
                    onClick={isUnlockData && (() => {
                      manipulateDataBasedOnChart(props?.aoperatingIncome, 4);
                    })}
                  >
                    {isUnlockData === true ? props.labelOperatingIncome : <span>{t("companyProfile.financial.operatingIncome")}: <DataMasking /></span>}
                  </button>
                </li>
              )}
              {props.renderIncomeBeforeTaxChart && (
                <li className="bt" role="none">
                  <button
                    aria-controls="chart_div7"
                    aria-selected="false"
                    data-vtab="vtab7"
                    id="bt_tab"
                    role="menuitem"
                    style={{ color: clickedButtonIndex === 5 ? "#3498db" : "" }}
                    onClick={isUnlockData && (() => {
                      manipulateDataBasedOnChart(props?.aincomeBeforeTax, 5);
                    })}
                  >
                    {isUnlockData === true ? props.labelIncomeBeforeTax : <span>{t("companyProfile.financial.incomeBeforeTax")}: <DataMasking /></span>}
                  </button>
                </li>
              )}
              {props?.renderNetIncomeChart && (
                <li className="ni" role="none">
                  <button
                    aria-controls="chart_div4"
                    aria-selected="false"
                    data-vtab="vtab4"
                    id="ni_tab"
                    role="menuitem"
                    style={{ color: clickedButtonIndex === 6 ? "#3498db" : "" }}
                    onClick={isUnlockData && (() => {
                      manipulateDataBasedOnChart(props?.atotalNetIncome, 6);
                    })}
                  >
                    {isUnlockData === true ? props.labelTotalNetIncome : <span>{t("companyProfile.financial.totalNetIncome")}: <DataMasking /></span>}
                  </button>
                </li>
              )}
              {props?.renderDilutedEPSChart && (
                <li className="eps" role="none">
                  <button
                    aria-controls="chart_div5"
                    aria-selected="false"
                    data-vtab="vtab5"
                    id="eps_tab"
                    role="menuitem"
                    style={{ color: clickedButtonIndex === 7 ? "#3498db" : "" }}
                    onClick={isUnlockData && (() => {
                      manipulateDataBasedOnChart(props?.adilutedEPS, 7);
                    })}
                  >
                    {isUnlockData === true ? props.labelDilutedEPS : <span>{t("companyProfile.financial.dilutedEPS")}: <DataMasking /></span>}
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      {/* </template> */}
    </>
  );
};

export default RevenueChartNew;
